/** 
* 自动生成文件，请勿修改 
* @name: 资产:设备管理模块
* @description: 设备管理模块-增删改查
* @create: 2024/1/11 下午4:25:21
* @swagger: 2.0
* 合计:8条
*/ 
 
import APIObject from "../utils/APIObject.js" 
const device = { 
	/** 1 summary:查询-所有数据	method:post */ 
	queryAll : new APIObject("/api/device/queryAll.do"), 
	/** 2 summary:查询-单条	method:post */ 
	queryOne : new APIObject("/api/device/queryOne.do"), 
	/** 3 summary:保存/修改-批量	method:post */ 
	batchSaveOrUpd : new APIObject("/api/device/batchSaveOrUpd.do"), 
	/** 4 summary:删除-单条	method:post */ 
	delete : new APIObject("/api/device/delete.do"), 
	/** 5 summary:启用/停用-批量(可单条)	method:post */ 
	batchModifyState : new APIObject("/api/device/batchModifyState.do"), 
	/** 6 summary:查询-分页	method:post */ 
	queryPage : new APIObject("/api/device/queryPage.do"), 
	/** 7 summary:保存/修改-单条	method:post */ 
	saveOrUpd : new APIObject("/api/device/saveOrUpd.do"), 
	/** 8 summary:删除-批量	method:post */ 
	batchDelete : new APIObject("/api/device/batchDelete.do"), 
};
export default device;